module.exports = __webpack_public_path__ + "img/icon22.0576b9d6.png";